import type { TourProps } from 'antd';
import { Tour } from 'antd';
import '../../Styles/TourGuide.css';
import { useEffect } from 'react';
import { useAuth } from 'src/AuthContext';

type Props = {
    isTourOpen: boolean;
    setIsTourOpen: React.Dispatch<React.SetStateAction<boolean>>;
}
const TourGuide: React.FC<Props> = ({isTourOpen, setIsTourOpen}) => {
  const { user } = useAuth();

  const steps: TourProps['steps'] = [
    {
      title: 'Start a New Project',
      description: 'Start from uploading your blueprints or with our 3D design tool.',
      target: () => document.querySelector('.add-new-project') as HTMLElement,
      placement: 'bottom',
      nextButtonProps: {
        children: 'Got it', // 👈 Custom text for finish button
      },
    },
  ];

  useEffect(() => {
    const handleTourStart = () => {
      if (!user.isInteriorDesigner) return;
      const key = 'estimatingTour';
      const now = Date.now();
      const savedTimestamp = localStorage.getItem(key);

      let openTour = false;

      if (!savedTimestamp) {
        // No timestamp stored → open tour
        openTour = true;
      } else {
        const lastTimestamp = parseInt(savedTimestamp, 10);
        const daysSinceLast = (now - lastTimestamp) / (1000 * 60 * 60 * 24); // convert ms → days

        if (daysSinceLast > 14) {
          openTour = true;
        }
      }
      if (openTour) {
        setIsTourOpen(true);
        localStorage.setItem(key, now.toString());
      }
    };

    handleTourStart();
  }, []);
  return (
    <Tour
       rootClassName='custom-tour-guide'
       open ={isTourOpen}
       onClose={() => setIsTourOpen(false)}
       steps={steps}
       disabledInteraction
    />
  );
};
export default TourGuide;
